import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { WizardService } from '../../../../../../service/wizard/wizard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'resumo-contribuinte-app',
  templateUrl: 'contribuinte.component.html',
  styleUrls: ['./contribuinte.component.scss'],
})
export class ResumoContribuinteComponent implements OnInit {
  routeSub: Subscription;
  perfil: string = '';
  index: number = 4;
  data: any = {};
  infoBasica = null;
  repLegal = null;
  procurador = null;
  prefeituras = null;
  tipo = null;
  semOutorga: boolean = false;
  termoAdesao: boolean = false
  
  @Output() onSelectTermo: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private wizardService: WizardService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    if (
      !this.wizardService.userData ||
      !this.wizardService.userData.infoBasica ||
      Object.keys(this.wizardService.userData.infoBasica).length === 0
    ) {
      const storedData = localStorage.getItem('data');
      if (storedData) {
        this.wizardService.userData = JSON.parse(storedData);
      }
    }
    
    this.data = this.wizardService.userData || {};
    this.infoBasica   = this.data.infoBasica || {};
    this.repLegal     = this.data.representanteLegal || {};
    this.procurador   = this.data.procurador || {};
    this.prefeituras  = this.data.prefeituras || [];
    this.tipo         = this.data.tipo || '';
    this.perfil       = this.data.perfil || '';
    
    this.semOutorga = (this.procurador && Object.keys(this.procurador).length > 0);
    
    console.log('Dados carregados:', this.data);
  }

  edit(index, title: string) {
    this.wizardService.updateIndex(index);
    let profile = this.perfil;
    switch (title) {
      case 'prefeituras':
        this.router.navigate(['cadastro', profile, title]);
        break;
      case 'dados':
        this.perfil === 'contribuinte'
          ? this.router.navigate(['cadastro/contribuinte/dados'])
          : this.router.navigate(['cadastro/procurador/dados-procurador']);
        break;
      case 'representante':
        this.router.navigate(['cadastro', profile, title]);
        break;
      default:
        this.router.navigate(['cadastro', profile, 'resumo']);
        break;
    }
  }

  termo() {
    console.log('evento dentro:',this.termoAdesao)
    this.onSelectTermo.emit(this.termoAdesao);
  }
}
